import React from 'react'
import RegularKekTableComponent from './HSMKEKComponent/RegularKeksList'
import { useSelector } from 'react-redux'
import LanguageStrings from '../../../i18n/locales'
import { type RootState } from '../../../store'

const HSMConfigurationStrings = LanguageStrings().HSMConfiguration.MainComponent

const MainRegularKeksList = (): JSX.Element => {
  const [isChecked, setIsChecked] = React.useState(false)
  const numOfKeks = useSelector((state: RootState) =>
    isChecked
      ? state.regularKekHsmStatus.kekList?.total_count ?? 0
      : state.regularKekList.regularKekList?.total_count ?? 0
  )
  return (
        <div>
            <div style={{ marginTop: '20px' }}>
                <div className='configurations-table-heading'>
                    <h5 data-testid='schedule-list'>{HSMConfigurationStrings.RegularHSMKeks} <span className='config-list-box'>{numOfKeks} {HSMConfigurationStrings.HSMKeks}</span></h5>
                </div>
                <RegularKekTableComponent isChecked={isChecked} setIsChecked={setIsChecked} />
            </div>
            <br />
        </div>
  )
}
export default MainRegularKeksList
